import { makeContextModule } from '@cian/react-utils';

import { IOfferCardContext } from '../types/offerContext';

export const { Context: OfferCardContext, useContext: useOfferCardContext } = makeContextModule<IOfferCardContext>({
  contextName: 'OfferCardContext',
});
